// extracted by mini-css-extract-plugin
module.exports = {"btnContactMaso":"ContactMaso_btnContactMaso__3tWTM","nonResizable":"ContactMaso_nonResizable__1N04T"};